<zxing-scanner #scanner (scanSuccess)="handleQrCodeResult($event)"></zxing-scanner>
